import axios from 'axios'
// import {
//   Dialog
// } from 'vant'



export function getFetch(url) {

  return new Promise((resolve, reject) => {
    axios.defaults.headers['Content-Type'] = 'application/json'
    axios.defaults.timeout = 20000;
    //axios.defaults.headers.common['X-AUTH-TOKEN'] = sessionStorage.site_current_token
    axios.get(url)
      .then(response => {
        resolve(JSON.stringify(response.data))
      })
      .catch((error) => {
        if (error.response) {
          console.log('error.response')
          console.log(error.response);
        } else if (error.request) {
          console.log(error.request)
          console.log('error.request')
          if (error.request.readyState == 4 && error.request.status == 0) {
            //我在这里重新请求
          }
        } else {
          console.log('Error', error.message);
        }
        console.log(error.config);

        reject(error)
      })
  })
}
export function fetch(url, params) {
  return new Promise((resolve, reject) => {
    axios.defaults.headers['Content-Type'] = 'application/json'
    axios.defaults.timeout = 20000;
    //axios.defaults.headers.common['X-AUTH-TOKEN'] = sessionStorage.site_current_token
    axios.post(url, params)
      .then(response => {
        resolve(JSON.stringify(response.data))
      })
      .catch((error) => {
        if (error.response) {
          console.log('error.response')
          console.log(error.response);
        } else if (error.request) {
          console.log(error.request)
          console.log('error.request')
          if (error.request.readyState == 4 && error.request.status == 0) {
            //我在这里重新请求
          }
        } else {
          console.log('Error', error.message);
        }
        console.log(error.config);

        reject(error)
      });
  })
}

export function formFetch(url, params) {

  return new Promise((resolve, reject) => {
    axios.defaults.headers['Content-Type'] = 'application/json'
    axios.defaults.timeout = 20000;
    //axios.defaults.headers.common['X-AUTH-TOKEN'] = sessionStorage.site_current_token
    axios.post(url, params)
      .then(response => {
        resolve(JSON.stringify(response.data))
      })
      .catch((error) => {
        if (error.response) {
          console.log('error.response')
          console.log(error.response);
        } else if (error.request) {
          console.log(error.request)
          console.log('error.request')
          if (error.request.readyState == 4 && error.request.status == 0) {
            //我在这里重新请求
          }
        } else {
          console.log('Error', error.message);
        }
        console.log(error.config);

        reject(error)
      });
  })
}

// export function formDataFetch(url, params) {
//   return new Promise((resolve, reject) => {
//     axios.defaults.headers['Content-Type'] = 'multipart/form-data'
//     axios.defaults.timeout = 20000;
//     //axios.defaults.headers.common['X-AUTH-TOKEN'] = sessionStorage.site_current_token
//     axios.post(url).data(params)
//       .then(response => {
//         resolve(JSON.stringify(response.data))
//       })
//       .catch((error) => {
//         if (error.response) {
//           console.log('error.response')
//           console.log(error.response);
//         } else if (error.request) {
//           console.log(error.request)
//           console.log('error.request')
//           if (error.request.readyState == 4 && error.request.status == 0) {
//             //我在这里重新请求
//           }
//         } else {
//           console.log('Error', error.message);
//         }
//         console.log(error.config);
//
//         reject(error)
//       })
//   })
// }

export function deleteFetch(url, params) {

  return new Promise((resolve, reject) => {
    axios.defaults.headers['Content-Type'] = 'application/json'
    axios.defaults.timeout = 20000;
    //axios.defaults.headers.common['X-AUTH-TOKEN'] = sessionStorage.site_current_token
    axios.delete(url, params)
      .then(response => {
        resolve(JSON.stringify(response.data))
      })
      .catch((error) => {
        if (error.response) {
          console.log('error.response')
          console.log(error.response);
        } else if (error.request) {
          console.log(error.request)
          console.log('error.request')
          if (error.request.readyState == 4 && error.request.status == 0) {
            //我在这里重新请求
          }
        } else {
          console.log('Error', error.message);
        }
        console.log(error.config);

        reject(error)
      });
  })
}



export default {
  //获取token 接口调用
  getServiceToken() {
    var data = JSON.stringify({
      query: '',
      variables: {}
    });
    const username = 'test';
    const password = '123456';
    return fetch('/hqyy/rest/tokens?username=' + username + '&password=' + password, data)
  },
  //根据code 获取用户信息
  getUserInfo(code) {
    return getFetch('/hqyy/rest/ltxtCcpdYhxxController/getbycode/' + code)
  },
  //根据openid获取用户信息
  getUserInfoByopenid(openid) {
    return getFetch('/hqyy/rest/ltxtCcpdYhxxController/getbyopid/' + openid)
  },
  //添加用户信息
  addUserInfo(openid, username, mobile) {
    var data = JSON.stringify({
      openid: openid,
      name: username,
      phone: mobile
    });
    return fetch('/hqyy/rest/ltxtCcpdYhxxController', data)
  },
  //绑定手机号码，姓名
  updateUserInfo(openid, username, mobile) {
    var data = JSON.stringify({
      openid: openid,
      name: username,
      phone: mobile
    });
    return fetch('/hqyy/rest/ltxtCcpdYhxxController/update', data)
  },
  //驾驶员
  beianJsz(data) {
    return fetch('/hqyy/rest/ltxtCcpdJsyxxController', data);
  },
  //获取驾驶员信息列表
  getDriverByOpenid(openid) {
    return getFetch('/hqyy/rest/ltxtCcpdJsyxxController/listbyopenid/' + openid)
  },
  //获取驾驶员备案详情
  getDriverBeianDetail(id) {
    return getFetch('/hqyy/rest/ltxtCcpdJsyxxController/getbyid/' + id)
  },
  //更新驾驶员备案
  updateBeianJsz(data) {
    return fetch('/hqyy/rest/ltxtCcpdJsyxxController/update/', data);
  },
  //删除驾驶员备案
  deleteBeianJsy(data) {
    return formFetch('/hqyy/rest/ltxtCcpdJsyxxController/delete/', data);
  },
  //停用驾驶员备案
  stopBeianJsy(data) {
    return fetch('/hqyy/rest/ltxtCcpdJsyxxController/stopjsyxx/', data);
  },

  //提交驾驶员信息审核
  submitBeianJsy(data) {
    return fetch('/hqyy/rest/ltxtCcpdJsyxxController/submitjsyxx/', data);
  },

  //公用
  //上传驾驶证图片
  uploadJszFront(data) {
    return formFetch('/hqyy/rest/ltxtCcpdJsyxxController/postupjszimg', data);
  },
  //上传驾驶证反面图片
  uploadJszFy(data) {
    return formFetch('/hqyy/rest/ltxtCcpdJsyxxController/postupjsyfmimg', data);
  },
  //上传从业资格证图片
  uploadCyzgz(data) {
    return formFetch('/hqyy/rest/ltxtCcpdJsyxxController/postupcyzgimg', data);
  },
  //上传从业资格证反面图片
  uploadCyzgzFm(data) {
    return formFetch('/hqyy/rest/ltxtCcpdJsyxxController/postupcyzgfmimg', data);
  },

  //押运员
  //备案押运员
  beianYsy(data) {
    return fetch('/hqyy/rest/ltxtCcpdYyyxxController', data);
  },
  //更新押运员备案
  updateBeianYsy(data) {
    return fetch('/hqyy/rest/ltxtCcpdYyyxxController/update/', data);
  },
  //停用
  stopBeianYsy(data)
  {
    return fetch('/hqyy/rest/ltxtCcpdYyyxxController/stopyyyxx/', data);
  },
  //删除押运员
  deleteBeianYsy(data) {
    return formFetch('/hqyy/rest/ltxtCcpdYyyxxController/delete/', data);
  },
  //获取押运员信息列表
  getEscortByOpenid(openid) {
    return getFetch('/hqyy/rest/ltxtCcpdYyyxxController/listbyopenid/' + openid)
  },
  //获取驾押运员备案详情
  getEscortBeianDetail(id) {
    return getFetch('/hqyy/rest/ltxtCcpdYyyxxController/getbyid/' + id)
  },
  //提交押运员信息审核
  submitBeianYsy(data) {
    return fetch('/hqyy/rest/ltxtCcpdYyyxxController/submityyyxx/', data);
  },


  //上传行驶证
  uploadXsz(type, data) {
    if (type == 'xsz_zb_zm') {
      return formFetch('/hqyy/rest/ltxtCcpdCtxxController/postupxszzbzm', data);
    } else if (type == 'xsz_zb_fm') {
      return formFetch('/hqyy/rest/ltxtCcpdCtxxController/postupxszzbfm', data);
    } else if (type == 'xsz_fb_zm') {
      return formFetch('/hqyy/rest/ltxtCcpdCtxxController/postupxszfbzm', data);
    } else if (type == 'xsz_fb_fm') {
      return formFetch('/hqyy/rest/ltxtCcpdCtxxController/postupxszfbfm', data);
    }
  },

  uploadXszCg(type, data) {
    if (type == 'xsz_zb_zm') {
      return formFetch('/hqyy/rest/ltxtCcpdCgxxController/postupxszzbzm', data);
    } else if (type == 'xsz_zb_fm') {
      return formFetch('/hqyy/rest/ltxtCcpdCgxxController/postupxszzbfm', data);
    } else if (type == 'xsz_fb_zm') {
      return formFetch('/hqyy/rest/ltxtCcpdCgxxController/postupxszfbzm', data);
    } else if (type == 'xsz_fb_fm') {
      return formFetch('/hqyy/rest/ltxtCcpdCgxxController/postupxszfbfm', data);
    }
  },


  //获取车头信息
  getChetouList(openid) {
    return getFetch('/hqyy/rest/ltxtCcpdCtxxController/listbyopenid/' + openid)
  },
  //获取车挂信息
  getCheguaList(openid) {
    return getFetch('/hqyy/rest/ltxtCcpdCgxxController/listbyopenid/' + openid)
  },

  //获取品种信息
  getPzList() {
    return getFetch('/hqyy/rest/viewLtpdErppinzhongController/listall')
  },
  //上传道路运输证正本正面图片
  uploadDlys(data) {
    return formFetch('/hqyy/rest/ltxtCcpdCtxxController/postupdlyszzbzm', data);
  },
  //上传道路运输 代理
  uploadDcl(type, data) {
    if (type == 'dcl_zm') {
      return formFetch('/hqyy/rest/ltxtCcpdCtxxController/postupdlyszdlzm', data);
    } else if (type == 'dcl_fm') {
      return formFetch('/hqyy/rest/ltxtCcpdCtxxController/postupdlyszdlfm', data);
    } else if (type == 'hb_scqd') {
      return formFetch('/hqyy/rest/ltxtCcpdCtxxController/postuphbscqd', data);
    }
  },
  //备案车头
  beianChetou(data) {
    return fetch('/hqyy/rest/ltxtCcpdCtxxController/', data);
  },
  updateBeianChetou(data) {
    return fetch('/hqyy/rest/ltxtCcpdCtxxController/update/', data);
  },
  //备案车头详情
  getChetouBeianDetail(id) {
    return getFetch('/hqyy/rest/ltxtCcpdCtxxController/getbyid/' + id);
  },
  //删除备案车头信息
  deleteBeianChetou(data) {
    return formFetch('/hqyy/rest/ltxtCcpdCtxxController/delete/', data);
  },
  stopBeianChetou(data) {
    return fetch('/hqyy/rest/ltxtCcpdCtxxController/stopctxx/', data);
  },
  submitBeianChetou(data)
  {
    return fetch('/hqyy/rest/ltxtCcpdCtxxController/submitctxx/', data);
  },
  //上传罐体图片
  uploadGtImage(data) {
    return fetch('/hqyy/rest/ltxtCcpdCgxxController/postupgjimg/', data);
  },
  //备案车挂
  beianChegua(data) {
    return fetch('/hqyy/rest/ltxtCcpdCgxxController/', data);
  },
  //备案车挂信息
  deleteBeianChegua(data) {
    return formFetch('/hqyy/rest/ltxtCcpdCgxxController/delete/', data);
  },
  stopBeianChegua(data) {
    return fetch('/hqyy/rest/ltxtCcpdCgxxController/stopcgxx/', data);
  },
  submitBeianChegua(data)
  {
    return fetch('/hqyy/rest/ltxtCcpdCgxxController/submitcgxx/', data);
  },
  //获取车挂信息
  getCheguaBeianDetail(id) {
    return getFetch('/hqyy/rest/ltxtCcpdCgxxController/getbyid/' + id);
  },
  updateBeianChegua(data) {
    return fetch('/hqyy/rest/ltxtCcpdCgxxController/update/', data);
  },
  //上传行驶证
  uploadCheguaXsz(type, data) {
    if (type == 'xsz_zb_zm') {
      return formFetch('/hqyy/rest/ltxtCcpdCgxxController/postupxszzbzm', data);
    } else if (type == 'xsz_zb_fm') {
      return formFetch('/hqyy/rest/ltxtCcpdCgxxController/postupxszzbfm', data);
    } else if (type == 'xsz_fb_zm') {
      return formFetch('/hqyy/rest/ltxtCcpdCgxxController/postupxszfbzm', data);
    } else if (type == 'xsz_fb_fm') {
      return formFetch('/hqyy/rest/ltxtCcpdCgxxController/postupxszfbfm', data);
    }
  },
  //查询可用预约清单old
  getYuyueList(openid, chetouhao, cheguahao, driverNo, escortNo) {
    return getFetch('/hqyy/rest/viewLtpdThtzdController/getfhtzd/' + openid + '/' + chetouhao + '/' + cheguahao + '/' + driverNo + '/' + escortNo);
  },

  //查询可用预约清单2023年5月20日
  getXhYuyueList(openid, chetouhao, cheguahao, driverNo, escortNo,inputBillNo) {
    ///{openid}/{txhdh}/{chetouhao}/{cheguahao}/{jiashiyuansfz}/{yayunyuansfz}
    return getFetch('/hqyy/rest/viewLtpdThtzdController/getxhtzdnew/' + openid + '/' + inputBillNo + '/' + chetouhao + '/' + cheguahao + '/' + driverNo + '/' + escortNo);
  },
  getThYuyueList(openid, chetouhao, cheguahao, driverNo, escortNo,inputBillNo) {
    return getFetch('/hqyy/rest/viewLtpdThtzdController/getfhtzdnew/' + openid + '/' + inputBillNo + '/' + chetouhao + '/' + cheguahao + '/' + driverNo + '/' + escortNo);
  },

  //查询可用预约清单卸货old
  getYuyueXhList(openid, chetouhao, cheguahao, driverNo, escortNo) {
    return getFetch('/hqyy/rest/viewLtpdThtzdController/getxhtzd/' + openid + '/' + chetouhao + '/' + cheguahao + '/' + driverNo + '/' + escortNo);
  },
  //查询可用时间
  getPdInfo(receivecorp, goodsname, ship, receiptdescription, ownername ,openid) {
    return getFetch('/hqyy/rest/viewLtpdPdxxController/getpdxx/' + receivecorp + '/' + goodsname + '/' + ship + '/' + receiptdescription + '/' + ownername + '/' + openid);
  },

  //查询可用时间
  getPdInfoNew(receivecorp, goodsname, ship, receiptdescription, ownername ,openid) {
    //hth 对应 openid
    var data = JSON.stringify({
      thdw: receivecorp,//thdw 对应提货单位
      pinzhong: goodsname,//pinzhong 对应 品种
      chetouhao: ship, //chetouhao 对应 车头号
      zylx: receiptdescription, //zylx 对应作业类型（提货或卸货）
      huozhu: ownername,//huozhu对应 货主
      hth: openid,//openid
    });
    return formFetch('/hqyy/rest/viewLtpdPdxxController/postpdxx/',data);
  },
  getPdInfoNew2(checiid, checixh,receiptdescription, ownername ,openid) {
    //hth 对应 openid
    var data = JSON.stringify({
      checiid: checiid,
      checixh: checixh,
      //zylx: receiptdescription, //zylx 对应作业类型（提货或卸货）
      //huozhu: ownername,//huozhu对应 货主
      hth: openid,//openid
    });
    return formFetch('/hqyy/rest/viewLtpdPdxxController/postpdxxnew/',data);
  },


  //添加预约
  addYuyue(openid, pdid) {
    var data = JSON.stringify({
      openid: openid,
      pdid: pdid
    });
    return fetch('/hqyy/rest/ltxtCcpdYyzbController', data);
  },

  //GET /rest/ltxtCcpdYyzbController/listshxxbyopenid/{openid}/{leibie}
  //查询可用预约清单
  getYuyueChose(openid, leibie) {
    return getFetch('/hqyy/rest/ltxtCcpdYyzbController/listshxxbyopenid/' + openid + '/' + leibie);
  },

  //查询绑定的车辆信息
  getVehicleInfo(openid) {
    return getFetch('/hqyy/rest/ltxtCcpdYhclController/getbyopenid/' + openid)
  },
  //绑定车辆
  bindVehicle(openid, chetouhao, cheguahao) {
    var data = JSON.stringify({
      openid: openid,
      chetouhao: chetouhao,
      cheguahao: cheguahao
    });
    return fetch('/hqyy/rest/ltxtCcpdYhclController', data);
  },
  //解绑车辆
  updateBindVehicle(openid, chetouhao, cheguahao) {
    var data = JSON.stringify({
      openid: openid,
      chetouhao: chetouhao,
      cheguahao: cheguahao
    });
    return fetch('/hqyy/rest/ltxtCcpdYhclController/updatebyopenid', data);
  },

  //模糊查询车头号
  searchChetou(search) {
    return getFetch('/hqyy/rest/ltxtCcpdCtxxController/listbyhao/' + search);
  },
  //模糊查询车尾号
  searchChegua(search) {
    return getFetch('/hqyy/rest/ltxtCcpdCgxxController/listbyhao/' + search);
  },
  //判断绑定状态
  getBindVehicleState(openid) {
    return getFetch('/hqyy/rest/ltxtCcpdYhxxController/getstate/' + openid)
  },



  getOrderList(openid, page) {
    return getFetch('/hqyy/rest/ltxtCcpdYyzbController/list/' + openid + '/' + page);
  },
  getNowOrderList(openid) {
    return getFetch('/hqyy/rest/ltxtCcpdYyzbController/listalluse/' + openid);
  },
  getOrderDetail(id) {
    return getFetch('/hqyy/rest/ltxtCcpdYyzbController/getbyid/' + id);
  },
  getxybyopenid(openid) {
    return getFetch('/hqyy/rest/ltpdCcpdYyaqgzController/getbyopenid/' + openid);
  },
  addxybyopenid(openid) {
    var data = JSON.stringify({
      openid: openid
    });
    return fetch('/hqyy/rest/ltpdCcpdYyaqgzController', data);
  },

  postupdzyd(data) {
    return formFetch('/hqyy/rest/ltxtCcpdYyzbController/postupdzyd/', data);
  },
  submitdzyd(data)
  {
    return fetch('/hqyy/rest/ltxtCcpdYyzbController/submitdzyd/', data);
  },
  submitxhbd(data)
  {
    return fetch('/hqyy/rest/ltxtCcpdYyzbController/submitxhbd/', data);
  },
  getSwipeList()
  {
    return getFetch('/hqyy/rest/ltxtCcpdSyimglistController/listall/');
  },
  //rest/viewLtpdErppinzhongController/isgeneralgood/{scope}
  isgeneralgood(scope)
  {
    return getFetch('/hqyy/rest/viewLtpdErppinzhongController/isgeneralgood/'+scope);
  },
  getsfscdzyd(yyid)
  {
    return getFetch('/hqyy/rest/viewLtpdErppinzhongController/getsfscdzyd/'+yyid);
  },
  getCns(openid)
  {
    return getFetch('/hqyy/rest/ltpdCcpdYyaqgzController/getbyopenid/'+openid);
  },
  createCns(data){
    return fetch('/hqyy/rest/ltpdCcpdYyaqgzController/', data);
  },
  uploadPicCommon(type,data){
    let requestUrl = '';
    switch (type) {
      case "deliveryPic":
        requestUrl = "/hqyy/rest/ltxtCcpdYyzbController/postupxhbd";
        break;
      case "deliveryxhPic":
        requestUrl = "/hqyy/rest/ltxtCcpdYyzbController/postupxhdzyd";
        break;
    }
    return formFetch(requestUrl, data);
  },
  getNotificationDetail(id)
  {
    return getFetch('/hqyy/rest/ltxtXtWxmessController/getwxmess/' + id);
  },
  getNoticeTipShow(id)
  {
    return getFetch('/hqyy/rest/ltxtCcpdShthjlController/getreturninfobyid/'+id)
  },
  updateyyctimg(data)
  {
    return fetch('/hqyy/rest/ltxtCcpdCtxxController/updateyyctimg/', data);
  },

}
